export default {
  form: {
    tax_id: {
      label: 'Numer podatkowy',
      placeholder: 'Wprowadź numer podatkowy',
    },
    has_vat: {
      label: 'Czy Twoja firma jest zarejestrowana jako podatnik VAT?',
    },
    vat_id: {
      label: 'VAT',
      placeholder: 'VAT',
      tooltip: 'Numer VAT to unikalny numer podatkowy identyfikujący Twoją firmę',
    },
    tax_percentage: {
      label: 'Stawka podatku',
      placeholder: 'Stawka podatku',
    },
    has_dedicated_products_tax: {
      label: 'Stawka podatku różni się w zależności od produktu',
    },
  },
  buttons: {
    next: 'Dalej',
    back: 'Wstecz',
    skip: 'Pomiń',
  },
};
